import { useEffect } from "react";
import ReactGA from "react-ga4";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

import { COOKIE_CONSENT_VALUES } from "@constants/cookies";
import { RootState } from "@store/index";
import { deleteAllCookies } from "@utils/common.utils";

const GoogleAnalyticsPageViewTracker = () => {
  const location = useLocation();
  const { consent } = useSelector((state: RootState) => state.cookieConsent);

  useEffect(() => {
    if (consent === COOKIE_CONSENT_VALUES.ALL) {
      ReactGA.send({ hitType: "pageview", page: location.pathname });
    } else {
      deleteAllCookies();
    }
  }, [location, consent]);

  return null;
};

export default GoogleAnalyticsPageViewTracker;
